<template lang="pug">
div
  b-card
    .row
      .col-md-12
        .white-box
          h1.box-title.m-b-0 技術情報編集
          p.text-muted.m-b-30.font-13 SWAN Proサイトの技術情報の編集画面
          .form-horizontal
            .form-group
              label.col-md-12 言語
              .col-md-12
                el-select(v-model='formData.locale', placeholder='Select', :disabled='disabled')
                  el-option(value='ja', label='日本語')
                  el-option(value='en', label='英語')
                  el-option(value='cn', label='中国語')
                  el-option(value='kr', label='韓国語')
            .form-group(v-if='formData.entry_id')
              label(for='他の言語').col-md-12 他の言語 
              .col-md-12
                a(v-if="formData.locale!='ja'" :href='locale_url.ja' replace) 日本語&nbsp;&nbsp;
                a(v-if="formData.locale!='en'" :href='locale_url.en' replace) 英語&nbsp;&nbsp;
                a(v-if="formData.locale!='cn'" :href='locale_url.cn' replace) 中国語&nbsp;&nbsp;
                a(v-if="formData.locale!='kr'" :href='locale_url.kr' replace) 韓国語&nbsp;&nbsp;
            .form-group
              label.col-md-12 タイトル
              .col-md-12
                el-input(type='text', value='', v-model='formData.category_name')
            .form-group
              label.col-md-12 カテゴリー
              .col-md-12
                el-select(v-model='formData.category', :disabled='disabled')
                  el-option(disabled, value='選択してください') ---選択してください---
                  el-option(value='standardEquipment', label='標準装備品')
                  el-option(value='swanBody', label='SWAN 本体')
                  el-option(value='scochGun', label='スコッチガン')
                  el-option(value='controlPanel', label='制御盤')
                  el-option(value='co-swan', label='防爆型塗装物搬送装置（コ・スワン Co-SWAN） 仕様')
                  el-option(value='onecupSystem', label='ワンカップシステム')
                  el-option(value='teachingAssist', label='SWANIST(ソフトウェア)')
            Format(v-if='formData.category === "standardEquipment" && formData.locale', :formatData='formData.objects')
            Swan(v-if='formData.category === "swanBody" && formData.locale', :swanData='formData.objects')
            ScochGun(v-if='formData.category === "scochGun" && formData.locale', :scochGunData='formData.objects')
            ControlPanel(v-if='formData.category === "controlPanel" && formData.locale', :controlPanelData='formData.objects')
            CoSwan(v-if='formData.category === "co-swan" && formData.locale', :coSwanData='formData.objects')
            OnecupSystem(v-if='formData.category === "onecupSystem" && formData.locale', :onecupSystemData='formData.objects')
            TeachingAssist(v-if='formData.category === "teachingAssist" && formData.locale', :teachingAssistData='formData.objects')
  .card
    .col-md-12
      publicSetting(apiname='tech-info', :formdata='formData')
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import PublicSetting from '@/views/components/swan/common/PublicSetting'

// 標準装備品
import Format from './Format'

// SWAN 本体
import Swan from './Swan'

// 搬送装置
import TransportDevice from './TransportDevice'

// スコッチガン
import ScochGun from './ScochGun'

// 制御盤
import ControlPanel from './ControlPanel'

// Co-Swan
import CoSwan from './CoSwan'

// ワンカップシステム
import OnecupSystem from './OnecupSystem'

// ティーチングシステム
import TeachingAssist from './TeachingAssist'

export default {
  name: 'TechInfoContent',
  data () {
    return {
      locale_url: {
        ja: '',
        en: '',
        cn: '',
        kr: ''
      },
      formData: {
        locale: '',
        entry_id: '',
        category: '',
        category_name: '',
        objects: {},
        disabled: Boolean,
        edit: Boolean,
        pageTitle: '',
        uploadedImages: [],
        images: [],
        open_date: '',
        close_date: '',
        created_at: '',
        updated_at: '',
        mod_date: '',
        status: '',
        agree_list: [],
        agree_user: ''
      }
    }
  },
  created () {
    let entryId = this.$route.query.id
    let locale = this.$route.query.locale
    this.formData.entry_id = entryId
    this.formData.locale = locale
    this.pageTitle = '新規作成'
    this.disabled = false
    this.edit = false
    this.formData.uploadedImages = []
    this.formData.images = []
    if (entryId && locale) {
      this.locale_url.ja = '?id=' + this.$route.query.id + '&locale=ja'
      this.locale_url.en = '?id=' + this.$route.query.id + '&locale=en'
      this.locale_url.cn = '?id=' + this.$route.query.id + '&locale=cn'
      this.locale_url.kr = '?id=' + this.$route.query.id + '&locale=kr'
      this.disabled = true
      this.edit = true
      this.pageTitle = '編集'
      axios({
        method: 'GET',
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/tech-info/edit?entry_id=' + entryId + '&locale=' + locale
      })
        .then((res) => {
          if (Object.keys(res.data).length > 0) {
            let content = res.data
            content.locale = this.$route.query.locale
            content.entry_id = this.$route.query.id
            content.created_at = moment(content.created_at).format('YYYY-MM-DD HH:mm')
            content.updated_at = moment(content.updated_at).format('YYYY-MM-DD HH:mm')
            if (content.open_at) {
              content.open_date = moment(content.open_at).format('YYYY-MM-DD')
              content.open_time = moment(content.open_at).format('HH:mm')
            } else {
              content.open_date = null
              content.open_time = null
            }
            if (content.close_at) {
              content.close_date = moment(content.close_at).format('YYYY-MM-DD')
              content.close_time = moment(content.close_at).format('HH:mm')
            } else {
              content.close_date = null
              content.close_time = null
            }
            content.uploadedImages = []
            content.images = []
            this.formData = content
            console.log(content)
          }
        })
        .catch((error) => {
          // 暫定的に作成されていない別言語の記事作成に対応するために記事IDと言語情報を格納
          this.formData.entry_id = this.$route.query.id
          this.formData.locale = this.$route.query.locale
          console.log(error)
        })
    }
  },
  methods: {
  },
  components: {
    Format,
    Swan,
    TransportDevice,
    ScochGun,
    ControlPanel,
    CoSwan,
    OnecupSystem,
    TeachingAssist,
    PublicSetting
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/techInfo/edit.vue